<template>
  <tr>
    <td>
      {{ item.name }}
    </td>
    <td>
      <div
        v-if="$userCheckAccess({abilities: 'edit_client_addresses'})"
        class="buttons"
      >
        <WorkClientOfficesModal :create="false" :id="item.id" />
        <DeleteModal
          :item="item"
          :text="
            localStorage.translations.pages['setting-client']['offices-dialog-delete']['udalit-filial'] +
            ' ' +
            item.name
          "
        />
      </div>
    </td>
  </tr>
</template>

<script>
import WorkClientOfficesModal from 'components/workClient/offices/WorkClientOfficesModal'
import DeleteModal from 'components/DeleteModal'

export default {
  name: 'WorkClientOfficesTableItem',
  components: { WorkClientOfficesModal, DeleteModal },
  props: ['item'],
}
</script>
